//otwieranie oraz zamykanie modala z listą nauczycieli
export const OPEN_SIGNIN_AS_TEACHER_MODAL = 'OPEN_SIGNIN_AS_TEACHER_MODAL';
export const CLOSE_SIGNIN_AS_TEACHER_MODAL = 'CLOSE_SIGNIN_AS_TEACHER_MODAL';

//pobranie listy nauczycieli w imieniu których może zalogować się supernauczyciel
export const GET_TEACHERS_START = 'GET_TEACHERS_START';
export const GET_TEACHERS_SUCCESS = 'GET_TEACHERS_SUCCESS';
export const GET_TEACHERS_FAIL = 'GET_TEACHERS_FAIL';

//zapisz do store wybranego nauczyciela
export const SET_SELECTED_TEACHER = 'SET_SELECTED_TEACHER';

//wysłanie requestu z prośbą o zalogowanie się jako dany nauczyciel
export const SIGNIN_AS_TEACHER_START = 'SIGNIN_AS_TEACHER_START';
export const SIGNIN_AS_TEACHER_SUCCESS = 'SIGNIN_AS_TEACHER_SUCCESS';
export const SIGNIN_AS_TEACHER_FAIL = 'SIGNIN_AS_TEACHER_FAIL';

//wysłanie requestu z prośbą o wylogowanie się (przelogowanie się) do konta macierzystego (supernauczyciela)
export const LOGOUT_AS_START = 'LOGOUT_AS_START';
export const LOGOUT_AS_SUCCESS = 'LOGOUT_AS_SUCCESS';
export const LOGOUT_AS_FAIL = 'LOGOUT_AS_FAIL';

export interface GetTeachers {
  type: typeof GET_TEACHERS_START;
  payload: { value: string };
}

//zarządzenie stanem modala
export interface OpenSigninAsTeacherModal {
  type: typeof OPEN_SIGNIN_AS_TEACHER_MODAL;
}
export interface CloseSigninAsTeacherModal {
  type: typeof CLOSE_SIGNIN_AS_TEACHER_MODAL;
}

//typy pomocnicze
export type SignAsTeacherPayload = { id: AppConfig.Teacher['prowadzacyPId'] };
export interface SignAsTeacher {
  type: typeof SIGNIN_AS_TEACHER_START;
}
export interface SetSelectedTeacher {
  type: typeof SET_SELECTED_TEACHER;
  payload: SignAsTeacherPayload;
}
export interface LogoutAs {
  type: typeof LOGOUT_AS_START;
}

export interface TeacherModal {
  opened: boolean;
  loading: boolean;
  error: boolean;
  selectedValue: AppConfig.Teacher['prowadzacyPId'] | null;
  teachers: AppConfig.Teacher[];
}

//interface stora
export interface AuthAsState {
  loading: boolean;
  error: boolean;
  teacherModal: TeacherModal;
}

export type AuthAsActionTypes =
  GetTeachers |
  SignAsTeacher |
  SetSelectedTeacher |
  LogoutAs |
  OpenSigninAsTeacherModal |
  CloseSigninAsTeacherModal;
